import React from 'react';
import * as Scrivito from 'scrivito';

Scrivito.provideWidgetClass('AboutUsWidget', {
  attributes: {
    image: 'reference',
    alt: 'string',
    name: 'string',
    jobDescription: 'string',
    description: 'string',
    headline: 'string',
    mail: 'string',
    fax: 'string',
    phone: 'string',
  },
});

const CONTACT_ROWS = [
  { attribute: 'mail', icon: 'ti-email' },
  { attribute: 'phone', icon: 'ti-headphone-alt' },
  { attribute: 'fax', icon: 'ti-harddrives' },
];

const AboutUsWidget = Scrivito.connect(({ widget }) => {
  // Rails printed all three contact rows unconditionally. Their icons came from
  // a font that had been 404'ing for years, so an empty row was simply invisible;
  // self-hosting the font turns those into a stray icon with nothing beside it –
  // visible on the card that has no contact details. Empty rows are dropped,
  // except while editing, where the fields have to stay reachable.
  const editing = Scrivito.isInPlaceEditingActive();
  const rows = CONTACT_ROWS.filter(
    ({ attribute }) => editing || widget.get(attribute)
  );

  return (
    <div className="team-wrap">
      <div className="team-align">
        <Scrivito.ImageTag
          content={widget}
          attribute="image"
          alt={widget.get('alt') || ''}
          className="img-responsive"
          loading="lazy"
        />
        <div className="text">
          {/* h3, not h4: no heading between this and the page's h2 section
              title, so axe's heading-order check flagged the skip. main.scss's
              `h2.black, h3.black, h4.black` rule already covers h3. */}
          <h3 className="black">
            <Scrivito.ContentTag tag="div" attribute="name" content={widget} />
          </h3>
          <span>
            <Scrivito.ContentTag tag="div" attribute="jobDescription" content={widget} />
          </span>
          <ul>
            {rows.map(({ attribute, icon }) => (
              <li key={attribute}>
                <span>
                  <i className={icon} />
                  <Scrivito.ContentTag tag="p" attribute={attribute} content={widget} />
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
});

Scrivito.provideComponent('AboutUsWidget', AboutUsWidget);

Scrivito.provideEditingConfig('AboutUsWidget', {
  title: 'Team Member',
  properties: ['image', 'alt', 'name', 'jobDescription', 'mail', 'phone', 'fax', 'description', 'headline'],
  attributes: {
    image:          { title: 'Photo' },
    alt:            { title: 'Image Alt Text' },
    name:           { title: 'Name' },
    jobDescription: { title: 'Job Title / Role' },
    mail:           { title: 'Email Address' },
    phone:          { title: 'Phone Number' },
    fax:            { title: 'Fax Number' },
    description:    { title: 'Description' },
    headline:       { title: 'Headline' },
  },
});

export default AboutUsWidget;
